/**
 * @fileoverview Hook for managing navigation state. Composes data fetching
 * and navigation building into a unified interface.
 */

import type { UseNavigationReturn } from '../types';
import { useNavigationData } from './useNavigationData';
import { useNavigationBuilder } from './useNavigationBuilder';

export type { UseNavigationReturn };

/**
 * Returns the current navigation tree with loading and error states.
 * Composes useNavigationData (fetching) and useNavigationBuilder (transformation).
 */
export function useNavigation(): UseNavigationReturn {
  const { data, loading, error, dataLoaded, refresh } = useNavigationData();

  const navigation = useNavigationBuilder({
    projects: data.projects,
    resources: data.resources,
    areas: data.areas,
    dataLoaded,
  });

  return {
    navigation,
    loading,
    error,
    refresh,
  };
}
